import './CTGY.scss';
import {PageManager} from 'genesis-packages/core';
import 'extensions/ui-components/x-product-card';
import {initCarousels} from 'extensions/carousel';
import 'extensions/quantify/quantify.js';
import ProductCards from 'extensions/product-card/ProductCards.js';
import AjaxAddToWishlist from 'extensions/AjaxAddToWishlist/AjaxAddToWishlist.js';
import PDFViewer from 'extensions/PDFViewer/PDFViewer';

export default class CTGY extends PageManager {

	constructor (pageContext) {
		super(pageContext);
	}

	onReady () {
		this.initFacets();
		initCarousels();

		new ProductCards({
			apiUrl: this.pageContext.JSON_Url,
			storeCode: this.pageContext.Store_Code
		});

		new PDFViewer(this.pageContext.PDF_Viewer_Url, true);

		const atwlForms = document.getElementsByClassName('js-product-card__form-atwl');

		for (let atwlForm of atwlForms) {
			new AjaxAddToWishlist(
				atwlForm,
				{
					submitButtonElements: '.js-product-atwl'
				}
			);
		}
	}

	async initFacets () {
		const facetsContainerElement = document.getElementById('js-facets');

		if (!facetsContainerElement) {
			return;
		}

		const {Facets} = await import('extensions/facets');

		new Facets(facetsContainerElement);
	}
}
